import { render, staticRenderFns } from "./QuitApplicationButton.vue?vue&type=template&id=3fdec497&scoped=true"
import script from "./QuitApplicationButton.vue?vue&type=script&lang=ts"
export * from "./QuitApplicationButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdec497",
  null
  
)

export default component.exports